<template>
	<section>
	<div>
		<div class="row map-container">
			<div class="col-md-8 pr-0">
				<GmapMap
					:center="{lat:currentLocation.lat, lng:currentLocation.lng}"
					:zoom="zoom"
					map-type-id="terrain"
					ref="map"
					class="google-map"
					>
				<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
					<div class="info-window">
					<p><b>{{infoContent.name}}</b></p>
					<p>{{infoContent.address}}</p>
					<p>{{infoContent.city}}, {{infoContent.state}} {{infoContent.zip}}</p>
					<p>{{infoContent.phone}}</p>
					<p>{{infoContent.open}} - {{infoContent.close}}</p>
					</div>
				</gmap-info-window>
				<GmapMarker
					:key="index"
					v-for="(m, index) in markers"
					:position="m.position"
					:clickable="true"
					@click="toggleInfoWindow(m,index)"
				/>
				</GmapMap>
			</div>

			<div class="col-md-4 pl-md-0 pr-0">
				<store-list :markers="markers"/>
			</div>
		</div>
	</div>
	</section>
</template>

<script>
import otcLocations from '@/data/otcLocations'
import StoreList from '@/components/StoreList'
export default {
		name: 'GoogleMap',
		components: {
		StoreList
	},

	data () {
		return {
			otcLocations,
			currentLocation : { lat : 14.5995, lng : 120.9842},	// default lat/long for Manila
			zoom: 10,
			infoContent: {},
			infoWindowPos: null,
			infoWinOpen: false,
			currentMidx: null,
			placeholder: '',
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			markers: [],
			place: null,
			radius: 100,
			radiusConverted: Number(this.radius) * 1609.344,
		}
	},
	methods: {
		toggleInfoWindow (marker, idx) {
			this.infoWindowPos = marker.position
			this.infoContent = marker.infoText
			if (this.currentMidx === idx) {
			this.infoWinOpen = !this.infoWinOpen
			} else {
			this.infoWinOpen = true
			this.currentMidx = idx
			}
		},
		computeDistance () {
			this.markers.forEach(marker => {
			let center = new google.maps.LatLng(this.center)
			let targetLoc = new google.maps.LatLng(marker.position)
			let distance = google.maps.geometry.spherical.computeDistanceBetween(center, targetLoc)
			marker['distance'] = distance
			})
		},
		setPlace (place) {
			this.center = {
			lat: place.geometry.location.lat(),
			lng: place.geometry.location.lng()
			}
			this.place = place
			this.computeDistance()
		},
		convertRadius () {
			this.radiusConverted = Number(this.radius) * 1609.344
		},
		filterMarkers () {
			this.markers = this.markers.filter(marker => marker.distance < this.radiusConverted)
		},
		sortMarkers () {
			this.markers.sort((a, b) => a.distance - b.distance)
		},
		updateLocations () {
			this.convertRadius()

			// filter and sort markers
			this.filterMarkers()
			this.sortMarkers()

			// set map zoom higher for zoom in effect
			this.zoom = 7
		},
		geolocation : function() {
			navigator.geolocation.getCurrentPosition((position) => {
				this.currentLocation = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};
			});
		}
	},

	created() {
		this.otcLocations.map(element => {
			this.markers.push(
			{
				position: {
					lat: Number(element.lat),
					lng: Number(element.lng)
				},
				infoText: {
					name: element.name,
					address: element.address,
					city: element.city,
					state: element.state,
					zip: element.zip_code,
					phone: element.phone_number,
					open: element.open,
					close: element.close
				}
			}
			)
		})
	},
	mounted(){
		this.geolocation(); // center map to user's location
	}
}
</script>

<style scoped>
	.info-window p {
		margin-bottom: 5px
	}
	.vue-map-container {
		display: inline-block;
		width: 100%;
		height: 550px;
	}
	.search {
		padding: 12px 0;
		text-align: center;
		background-color: #eee;
	}
	.search button {
		margin-left: 10px;
		padding: 2px .75rem;
	}
	label {
		padding-right: 10px;
		margin-bottom: 0;
	}
	select {
		height: 31px;
	}
	.google-map{
		height: 500px;
	}
</style>

